<div class="estimation-progress-wrap mx-auto" [ngClass]="spinnerTextColor"
     [ngStyle]="{'height': height+'px', 'width':height+'px'}">
    <span class="estimation-progress-value" [ngClass]="{'_global-estimation':globalEstimation}" [ngStyle]="{'line-height': height+'px', 'font-size':labelFontSize+'rem'}">{{percent}}%</span>
    <mat-progress-spinner mode="determinate" [value]="percent"
                         class="estimation-progress-spinner" [ngClass]="{'_global-estimation':globalEstimation}" [color]="spinnerColor"></mat-progress-spinner>
</div>
